export default {
  viewAll: '查看全部',
  clearHistory: '清除历史',
  noGamesAvailable: '暂无游戏',
  showMore: '显示更多',
  showLess: '收起',
  loading: '加载中...',
  error: '出错了',
  retry: '重试',
  cancel: '取消',
  confirm: '确认',
  save: '保存',
  delete: '删除',
  edit: '编辑',
  close: '关闭',
  submit: '提交',
  back: '返回',
  next: '下一步',
  searchPlaceholder: '搜索游戏...',
  search: '搜索',
  noMoreGames: '没有更多游戏了',
  backToTop: '回到顶部'
}; 